/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React from 'react';
import { connect } from 'react-redux';
import CountUp from 'react-countup';
import Qua from '@tencent/parse-qua';
import { setDialogs } from '../../../actions';
import qbJsapi from '../../../lib/qb/jsapi';
import { setLocalStorage, getLocalStorage } from '../../../lib/util/utils';
import moment from 'moment';
import compareVersions from 'compare-versions';

import { $http, openWebViewWithType } from '../../../lib/kbApp/kbJsBridgePromise';
import { reportUrl, NOVEL_WELFARE_PAGE_ADDR  } from '../../../const/index';
import { detector } from '../../../lib/util/Detect';
import { setWelfareAnimation, setProperty } from '../../../rootStore';
import sendBoss from '../../../lib/base/sendBoss';
import './index.scss';
import '../../../common/css/animate-flowers.scss';

class SignInCoinDialog extends React.Component {
  cacheKey = `dialog#click#novel_nav${moment().format('YYYY-MM-DD')}`

  constructor(props) {
    super(props);
    this.state = {
      showFlowerAnim: true,
      // 是否引导到小说
      leadToNovel: false,
      qua2: '',
    };
    this.Log = this.props.Log;
  }

  async componentDidMount() {
    const { welfare } = this.props;
    const coupons = welfare.coupons || [];
    const { showUrls = [] } = coupons[0] || {};
    try {
      showUrls.forEach((url) => {
        // $http.get(url);
        const img = new Image();
        img.src = url;
        sendBoss('element_exposure', {
          element_type: 'signInCoinDialog',
          element_name: 'coupon',
          extra_info: { showUrl: url },
        });
      });
      // 获取QUA, 通过PPVN给到的产品版本号加以判断，jsapi返回的版本号不精确
      const qua = await qbJsapi.getQua2();

      const checkIfToNovelRet = this.checkIfToNovel(qua);

      if (checkIfToNovelRet.code === 0) {
        this.setState({
          leadToNovel: true,
          qua2: encodeURIComponent(qua),
        });
      }

      sendBoss('element_exposure', {
        element_type: 'signInCoinDialog',
        element_name: 'defaultsign_popup_success',
        extra_info: `checkIfToNovelRet=${JSON.stringify(checkIfToNovelRet)}`,
        qua2: encodeURIComponent(qua),
      });
    } catch (error) {
      console.log('exporse click url error', error);
      sendBoss('element_exposure', {
        element_type: 'signInCoinDialog',
        extra_info: { showUrlError: error },
      });
    }

    setTimeout(() => {
      this.setState({ showFlowerAnim: false });
    }, 1600);
  }

  close = (scene) => {
    sendBoss('element_click', {
      element_type: 'signInCoinDialog',
      element_name: `close_${scene}`,
    });

    this.props.dialogs.pop();
    this.props.dispatch(setDialogs(this.props.dialogs));

    setWelfareAnimation();

    // 给资产加金币和现金
    const { value, welfareType } = this.props;
    setProperty({ value, welfareType });
  }

  contentRender = () => {
    const { welfare = {}, value, welfareType, kbApp = {} } = this.props;
    const coupons = welfare.coupons && welfare.coupons.length > 0 ? welfare.coupons : [{}];
    const { source, title, icon } = coupons[0];

    if (welfareType === 6) {  // 卡券奖励
      const userInfo = kbApp.userInfo || {};

      return (
        <React.Fragment>
          <div className="congra vip">恭喜获得腾讯视频会员VIP{value}天</div>
          <div className="prizeVip"></div>
          <div className="account">
            使用此账号
						<span className="avator"><img src={userInfo.avatar} /></span>
            <span className="nickname">{userInfo.nick || ''}</span>
          </div>
          <div className="tip">登录 [腾讯视频] 即可使用</div>
        </React.Fragment>
      );
    } if (welfareType === 0 || welfareType === 4) {  // 现金奖励
      const formateValue = `${value / 100}`.split('.');
      const decimals = formateValue.length > 1 ? formateValue[1].length : 0;
      return (
        <React.Fragment>
          <div className="congra">恭喜获得现金</div>
          <CountUp start={0} end={value / 100} delay={0} decimals={decimals}>
            {({ countUpRef }) => (
              <div className="num">
                <span ref={countUpRef} />
                <span className="yuan">元</span>
              </div>
            )}
          </CountUp>
        </React.Fragment>
      );
    } if (welfareType === 3 || welfareType === 5) {  // 金币奖励
      return (
        <React.Fragment>
          <div className="congra">恭喜获得金币</div>
          <CountUp start={0} end={value} delay={0}>
            {({ countUpRef }) => (
              <div className="num">
                <span className="plus"></span>
                <span ref={countUpRef} />
              </div>
            )}
          </CountUp>
        </React.Fragment>
      );
    } if (welfareType === 1 || welfareType === 2) {  // 礼券广告
      return (
        <React.Fragment>
          <div className="congra">恭喜获得一张礼券</div>
          <div className="coupon">
            <div className="info">
              <h4>{source}</h4>
              <div className="ticket-title">{title}</div>
            </div>
            <img src={icon} className="icon" />
          </div>
        </React.Fragment>
      );
    }
  }

  btnRender = () => {
    const { leadToNovel } = this.state;
    const { welfareType } = this.props;

    if (welfareType === 1 || welfareType === 2) {  // 礼券广告
      return (
        <div className="btn" onClick={() => this.couponClick()} log-click-eltype="confirm" log-click-elname="view_detail">立即查看</div>
      );
    }

    const btnText = leadToNovel ? '读小说去赚钱' : '继续赚钱';

    return <div
      className="btn"
      onClick={ () => {
        this.confirmClick(leadToNovel ? 'novel' : 'default');
        this.props.confirmCb && this.props.confirmCb();
      } }
      log-click-eltype="confirm"
      log-click-elname="keep_doing"
    >{ btnText }</div>;
  }

  /**
   * @desc 确认点击事件
   * scene：场景值，决定交互行为
   */
  confirmClick = (scene) => {
    // 默认场景直接关闭弹窗
    if (!scene || scene === 'default') {
      return this.close(scene);
    }

    if (scene === 'novel') {
      this.goToNovelWelfarePage();
    }
  }

  /**
   * @desc 前往小说福利中心
   *
   * @memberof SignInCoinDialog
   */
  goToNovelWelfarePage = () => {
    const { qua2 } = this.state;

    setLocalStorage(this.cacheKey, 1);

    sendBoss('element_click', {
      element_type: 'signInCoinDialog',
      element_name: 'goToNovelWelfarePage',
      qua2,
    });

    setTimeout(() => {
      window.location.href = NOVEL_WELFARE_PAGE_ADDR;
    }, 20);
  }

  /**
   * @desc 校验是否要引导至小说
   * 1.优先判断本地缓存是否用户当日已经点击过引导按钮了
   * 2.判断是否下发了小说任务
   * 3. 判断当前版本是否展示了小说tab
   *
   * @memberof SignInCoinDialog
   */
  checkIfToNovel = (qua) => {
    const ret = {
      code: 0,
      msg: '',
    };

    try {
      // 判断今天是否已经点击过引导按钮
      if (getLocalStorage(this.cacheKey)) {
        ret.code = -1;
        ret.msg = 'has clicked today';
        return ret;
      }

      const { dailyTaskRaw = [] } = this.props;

      // 小说时长任务
      const hasNovelTask = dailyTaskRaw.some(task => task.businessId === 301);

      if (!hasNovelTask) {
        ret.code = -1;
        ret.msg = 'no hasNovelTask';
        return ret;
      };

      const compareVersion = detector.os.android ? '11.4.1.602' : '11.4.1';


      if (!qua) {
        ret.code = -1;
        ret.msg = 'qua missing';
        return ret;
      };
      const version = new Qua(qua).getValueByKey('PPVN');

      const isOk = compareVersions(version, compareVersion) >= 0;

      ret.msg = isOk;

      return ret;
    } catch (error) {
      console.log('checkIfToNovel error', error.message);
      ret.code = -1;
      ret.msg = error.message;
      return ret;
    }
  }

  couponClick = () => {
    const { welfare } = this.props;
    const coupons = welfare.coupons || [];
    const { clickUrls = [], usepage = [], ticket = '' } = coupons[0] || {};
    sendBoss('element_click', {
      element_type: 'signInCoinDialog',
      element_name: 'coupon_detail_btn',
      extra_info: {
        coupons: coupons[0],
      },
    });
    try {
      if (detector.app.kuaibao) {
        $http.get(`${reportUrl}?ticket=${ticket}&action=click&actionTime=${new Date().getTime() * 1000}`);
      } else {
        clickUrls.forEach((url) => {
          $http.get(url);
        });
      }
    } catch (error) {
      console.log('exporse click url error', error);
    }

    this.close();
    if (detector.app.kuaibao) {
      openWebViewWithType(usepage);
    } else {
      window.location.href = usepage;
    }
  }

  render() {
    return (
      <div className="signInCoinDialog">
        <div className={`gka-flower-wrap ${this.state.showFlowerAnim ? 'flower-animation' : ''}`}></div>
        <div className="dialog">
          <div className="coinDialog">
            <div className="bag">
              <div className="bag-coin"></div>
            </div>
            <div className="board">
              <div className="status">{this.props.from === 'task' ? '领取成功' : '签到成功'}</div>
              {this.contentRender()}
              {this.btnRender()}
            </div>
          </div>
          <div className="close" onClick={this.close} log-click-eltype="close"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { dialogs, kbApp, myIntegral, dailyTaskRaw } = state;
  return {
    dialogs,
    kbApp,
    myIntegral,
    dailyTaskRaw,
  };
};

export default connect(mapStateToProps)(SignInCoinDialog);
